<template>
  <div>
    <Header />
    <div class="container">
      <b-row>
        <b-col
          md="6"
          lg="6"
          offset-lg="3"
          offset-md="3"
          xs="12"
        >
            <b-card
              v-if="!tokenValid"
            >
              <b-alert
                variant="warning"
                show
              >
                <h4 class="alert-heading">
                  {{ $t('DEBTIA_COMMON_CAUTION') }}
                </h4>
                <div class="alert-body">
                  {{ $t('DEBTIA_TOKEN_EXPIRED') }}
                </div>
              </b-alert>
            </b-card>
            <b-card
              v-else
              footer-class="text-muted"
            >
              <div id="my-container">
                <b-card
                  :title="$t('DEBTIA_FORGOT_ENTER_NEW_PASSWORD')"
                >
                  <validation-observer ref="simpleRules">
                    <b-form>
                      <b-row>
                        <b-col cols="12">
                          <b-form-group
                            :label="$t('DEBTIA_NEW_PASSWORD')"
                            label-for="h-password"
                            label-cols-md="4"
                          >
                            <validation-provider
                              #default="{ errors }"
                              name="Password"
                              vid="Password"
                              rules="required"
                            >
                              <b-form-input
                                id="h-password"
                                v-model="password"
                                type="password"
                                :placeholder="$t('DEBTIA_FORGOT_NEW_PASSWORD_PH')"
                              />
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12">
                          <b-form-group
                            :label="$t('DEBTIA_RETYPE_NEW_PASSWORD')"
                            label-for="h-password"
                            label-cols-md="4"
                          >
                            <validation-provider
                              #default="{ errors }"
                              name="Confirm Password"
                              rules="required|confirmed:Password"
                            >
                              <b-form-input
                                id="h-password"
                                v-model="retype_password"
                                type="password"
                                :placeholder="$t('DEBTIA_FORGOT_RETYPE_PASSWORD_PH')"
                              />
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </b-form-group>
                        </b-col>

                        <!-- submit and reset -->
                        <b-col offset-md="4">
                          <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            type="submit"
                            variant="primary"
                            class="mr-1"
                            @click.prevent="validationForm"
                          >
                            {{ $t('DEBTIA_SUBMIT') }}
                          </b-button>
                        </b-col>
                      </b-row>

                    </b-form>
                  </validation-observer>
                </b-card>
              </div>
            </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard,
  BRow,
  BCol,
  BFormGroup, BFormInput, BForm, BButton, BAlert,
} from 'bootstrap-vue'
import {
  required, confirmed,
} from '@validations'
import Ripple from 'vue-ripple-directive'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Header from './Header.vue'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BCard,
    BRow,
    BCol,
    Header,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BAlert,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      creditor: 'Claim on the behalf of XYZ',
      required,
      confirmed,
      retype_password: '',
      password: '',
      forgetpasswordloader: false,
      tokenValid: false,
      username: '',
      email: '',
    }
  },
  watch: {
    forgetpasswordloader(val) {
      this.$store.commit('app/SET_GLOBAL_LOADING', { show: val, text: this.$t('DEBTIA_LOADING_RESET_PASSWORD') })
    },
  },
  beforeDestroy() {
    this.$store.commit('app/SET_GLOBAL_LOADING', false)
  },
  created() {
    this.validateToken()
  },
  methods: {
    async validateToken() {
      const { token } = this.$route.params
      this.forgetpasswordloader = true
      await axios.get(`/verify-password-reset-link/${token}`)
        .then(response => {
          this.tokenValid = true
          this.username = response.data.data.username
          this.email = response.data.data.email
        }).catch(() => {
          this.tokenValid = false
        })
      this.forgetpasswordloader = false
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          const obj = {
            username: this.username,
            email: this.email,
            token: this.$route.params.token,
            password: this.password,
            password_confirmation: this.retype_password,
          }
          axios.post('/reset-password', obj)
            .then(response => {
              this.password = ''
              this.retype_password = ''
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: this.$t('DEBTIA_COMMON_SUCCESS'),
                  icon: 'CoffeeIcon',
                  variant: 'success',
                  text: response.data.message,
                },
              })
              this.$router.push('/login')
            }).catch(response => {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: this.$t('DEBTIA_TOAST_REQUEST_FAILED'),
                  icon: 'CoffeeIcon',
                  variant: 'danger',
                  text: response.data.message,
                },
              })
              // this.tokenValid = false
            })
        }
      })
    },
  },
}
</script>
<style lang="scss">
  @import '@core/scss/vue/libs/vue-wizard.scss';
  @import '@core/scss/vue/libs/vue-select.scss';

  .custom {
    background: $primary;
  }
  .right-values{
    float: right;
  }
  @media only screen and (max-width: 767px){
    #spinner-div{
      height: 80%;
    }
  }
  @media only screen and (min-width: 767px){
    #spinner-div{
      height: 50%;
    }
  }
  #spinner-div{
    background-color: #f1efef;
    width: 100%;
    position: absolute;
    border-radius: 10px;
    z-index: 1;
    opacity: 0.7;
  }

  .custom-spinner-style{
    margin-left: 50%;
    margin-top: 10%;
  }
  .vue-form-wizard .wizard-nav-pills {
    display: flex;
    justify-content: center;
  }

  .btn-group.btn-group-lg{
    display: flex !important;
    justify-content: center;
  }

  .popover-body{
    padding: 12px 5px !important
  }

  .alert-div{
    padding: 10px;
    border: 1px solid #ff6e6e;
    border-radius: 6px;
    background-color: #ffe7e7;
    color: #ff5252;
  }

  @media only screen and (max-width: 767px){
    .btn-group-lg > .btn{
      font-size: 0.75rem;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }
  }
</style>
